// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  restaurantId: __t.u64(),
  memberId: __t.string(),
  role: __t.string(),
  homeFloor: __t.u32(),
  homeX: __t.f32(),
  homeZ: __t.f32(),
  spawnX: __t.f32(),
  spawnZ: __t.f32(),
  spawnFloor: __t.u32(),
};
